module.exports = __webpack_public_path__ + "img/KarbalaAirport2.e6e05267.jpg";